
/* injects from baggage-loader */

'use strict';

import InvestmentConfirmationController from './investment-confirmation.controller';
import InvestmentConfirmationTemplate from './investment-confirmation.html';

export default class InvestmentConfirmationComponent {
		constructor() {
				this.templateUrl = InvestmentConfirmationTemplate;
				this.controller = InvestmentConfirmationController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = { };
		}
}
